import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { Container } from 'reactstrap';

import {
  fetchPeople,
  clearPeople,
} from '../actions/People';

import PeopleHeader from '../components/People/Header';
import PeopleItem from '../components/People/Item';
import TrialNotice from '../components/TrialNotice';

import EmptyPeople from './EmptyContainers/People';
import Loading from '../components/Loading';

import { getSetting } from '../helpers/Settings';

const People = ({
  dispatch,
  people,
  peopleTotal,
  peopleLoading,
}) => {
  const userHasFaceRecognition = getSetting('face_recognition');

  const loadMore = () => {
    if (userHasFaceRecognition) {
      dispatch(fetchPeople());
    }
  };

  useEffect(() => {
    if (userHasFaceRecognition) {
      dispatch(clearPeople());
      dispatch(fetchPeople());
    }

    return () => {
      dispatch(clearPeople());
    };
  }, [dispatch, userHasFaceRecognition]);

  return (
    <div className="main-content split-content page-people">
      <div className="split-content-wrapper">
        <Container fluid>
          <PeopleHeader loaded={people.length} total={peopleTotal} />
          <TrialNotice feature="face-recognition" />
          <div className="content-wrapper people-wrapper">
            {people.length > 0 ? (
              <div className="people-list">
                {people.map(person => (
                  <PeopleItem
                    key={person.uuid}
                    person={person}
                  />
                ))}
              </div>
            ) : (
              <>
                {!peopleLoading && (
                  <EmptyPeople />
                )}
              </>
            )}
            {peopleLoading ? (
              <Loading />
            ) : (
              <Waypoint
                bottomOffset="-50px"
                onEnter={() => { loadMore(); }}
              />
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  people: state.People.people,
  peopleTotal: state.People.total,
  peopleLoading: state.People.loading,
});

People.propTypes = {
  dispatch: PropTypes.func.isRequired,
  people: PropTypes.array.isRequired,
  peopleTotal: PropTypes.number.isRequired,
  peopleLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(People);
